import { render, staticRenderFns } from "./ConfirmacionMensaje.vue?vue&type=template&id=3b789ac4"
import script from "./ConfirmacionMensaje.vue?vue&type=script&lang=js"
export * from "./ConfirmacionMensaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports